export default __webpack_public_path__ + "static/media/aboutIsa-03.959257bd.jpg";